import { AAGUID } from '@interticket/core';
import { ICartItem } from '@core/interfaces/cart/cart-item.interface';
import { EventVenueType } from '@core/enums/event/event-venue-type.enum';

export class CartItem implements ICartItem {

  readonly slotId: AAGUID;
  readonly selectionId: AAGUID;
  readonly eventId: AAGUID;
  readonly priceCategoryId: AAGUID;
  readonly price: number;
  readonly ownerId: AAGUID;
  readonly expiredTime: string;
  readonly eventType: EventVenueType;
  readonly id: AAGUID;
  readonly originalPrice?: number;
  readonly discountName?: string;
  readonly discountId?: AAGUID;

  constructor(iCartItem: ICartItem) {
    this.slotId = iCartItem.slotId;
    this.selectionId = iCartItem.selectionId;
    this.eventId = iCartItem.eventId;
    this.priceCategoryId = iCartItem.priceCategoryId;
    this.price = iCartItem.price;
    this.ownerId = iCartItem.ownerId;
    this.expiredTime = iCartItem.expiredTime;
    this.eventType = iCartItem.eventType;
    this.id = iCartItem.id;
    this.originalPrice = iCartItem.originalPrice;
    this.discountName = iCartItem.discountName;
    this.discountId = iCartItem.discountId;
  }

}
